import script from "./WishList.vue?vue&type=script&lang=ts&setup=true"
export * from "./WishList.vue?vue&type=script&lang=ts&setup=true"

import "./WishList.vue?vue&type=style&index=0&id=2e3240ac&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e3240ac"]])

export default __exports__